import { CanDeactivateFn } from '@angular/router';

/** Covers sidebar links and browser Back as well as the editor's own Back button. */
export const pendingLessonChangesGuard: CanDeactivateFn<{ canDeactivate(): boolean }> =
  (component) => component.canDeactivate();
